<template>
  <div class="animated fadeIn">
    <basic-heading :title="'Print Received'" class="print-hidden mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" @buttonAction="handleAction" />
      </template>
    </basic-heading>
    <span ref="samples" class="pl-2 py-2">
      <SampleReceivingLabels
        :samples="sample_collection"
        :receive="false"
      />
    </span>
    <b-button @click="download">
      Download PDF
    </b-button>
  </div>
</template>

<script>
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import SampleReceivingLabels from '@/components/lab/sample/SampleReceivingLabels'
import SampleCollection from '@/collections/lab/SampleCollection'
import moment from 'moment'
import { downloadHtmlCanvas } from '@/shared/utils'
import DymoService from '@/dymo/DymoService'

export default {
  name: 'ReceiveBatchPrint',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    SampleReceivingLabels
  },
  props: {
    receiveList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      received_items: null,
      sample_collection: new SampleCollection()
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
          {
            icon: 'fa-list',
            linkto: '/samples/receive',
            title: 'To All receiving',
            variant: 'primary'
          },
          {
            icon: 'fa-tag mr-2',
            variant: 'success',
            text: 'Print All Label',
            with_action: true,
            action_data: 'print_label',
            disabled: this.sample_collection.length === 0
          }
        ]
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.convertReceiveListToSampleCollection()

      // initialize DYMO
      DymoService.initFramework()
    },
    convertReceiveListToSampleCollection () {
      this.sample_collection.replace(this.receiveList)
    },
    async download () {
      const { samples } = this.$refs

      const fileName = `received_samples_${moment().format('YYYY_MM_DD')}.pdf`

      downloadHtmlCanvas(samples, fileName)
    },
    async printLabel () {
      try {
        const labelXml = DymoService.createLabel('http://localhost:8084/js/labels/template.label')

        const printResult = await DymoService.printLabel(labelXml)
        console.log('Label printed successfully:', printResult)
      } catch (error) {
        console.error('Failed to print label:', error)
      }
    },
    handleAction (action) {
      if (action == 'print_label') {
        this.printLabel()
      }
    }
  }
}
</script>>
